// Panel de la herramienta "Texto": agregar cuadro + últimos textos usados.

import { Plus } from 'lucide-react';
import { makeText } from '../lib/factory';
import { getUltimosTextos } from '../lib/ultimosTextos';
import { PanelSheet } from './PanelSheet';
import type { SceneApi } from '../scene/useScene';

interface Props {
  api: SceneApi;
  onClose: () => void;
}

export function TextPanel({ api, onClose }: Props) {
  const ultimos = getUltimosTextos();
  const add = (text: string) => api.addLayer(makeText(text));

  return (
    <PanelSheet title="Texto" onClose={onClose}>
      <div className="flex-1 min-h-0 overflow-y-auto p-3 space-y-3">
        <button
          type="button"
          onClick={() => add('Tu texto acá')}
          className="w-full h-10 rounded-md bg-brand-primary hover:bg-brand-primary-hover text-white text-[14px] font-medium shadow-sm inline-flex items-center justify-center gap-2 active:scale-[0.99] transition-colors"
        >
          <Plus className="w-4 h-4" /> Agregar cuadro de texto
        </button>
        {ultimos.length > 0 && (
          <div>
            <p className="text-[11px] uppercase tracking-wide font-medium text-[#3C3C43]/55 mb-1.5">
              Últimos usados
            </p>
            <div className="space-y-1">
              {ultimos.map((t, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => add(t)}
                  className="w-full text-left px-3 py-2 rounded-md border border-neutral-200 hover:border-brand-primary/40 hover:bg-surface-elevated text-[13px] text-neutral-700 truncate transition-colors"
                >
                  {t}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </PanelSheet>
  );
}
